import { BLOCKS } from '@contentful/rich-text-types';
const stringToRichTextDocument = (text = '', nodeType = BLOCKS.PARAGRAPH) => ({
  content: [{
    content: [{
      data: {},
      marks: [],
      nodeType: 'text',
      value: text
    }],
    data: {},
    nodeType
  }],
  data: {},
  nodeType: BLOCKS.DOCUMENT
});
export { stringToRichTextDocument };
//# sourceMappingURL=stringToRichTextDocument.js.map
